import { render, staticRenderFns } from "./PreJoinTemplate.vue?vue&type=template&id=67725c87&scoped=true&"
import script from "./PreJoinTemplate.vue?vue&type=script&lang=js&"
export * from "./PreJoinTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PreJoinTemplate.vue?vue&type=style&index=0&id=67725c87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67725c87",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67725c87')) {
      api.createRecord('67725c87', component.options)
    } else {
      api.reload('67725c87', component.options)
    }
    module.hot.accept("./PreJoinTemplate.vue?vue&type=template&id=67725c87&scoped=true&", function () {
      api.rerender('67725c87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PreJoinTemplate.vue"
export default component.exports